import Joi from "joi";

export default Joi.object({
	username: Joi.string().required(),
	password: Joi.string().required(),
	authorized_nifs: Joi.array().items(Joi.string())
});
